import { cn } from '@/lib/utils'

/** Single-choice segmented control, styled like the other filter controls. */
export function StatusChips({
  value,
  onChange,
  options,
  labelledBy,
}: {
  value: string
  onChange: (next: string) => void
  options: Array<{ id: string; label: string }>
  labelledBy?: string
}) {
  return (
    <div role="group" aria-labelledby={labelledBy} className="flex flex-wrap gap-0.5 rounded-md border border-input bg-card p-0.5">
      {options.map((opt) => {
        const on = value === opt.id
        return (
          <button
            key={opt.id || 'all'}
            type="button"
            aria-pressed={on}
            onClick={() => onChange(opt.id)}
            className={cn(
              'h-8 rounded px-3 text-sm font-semibold transition-colors focus-visible:outline-2 focus-visible:outline-offset-1 focus-visible:outline-ring max-sm:h-11 max-sm:flex-1',
              on ? 'bg-primary text-primary-foreground' : 'text-muted-foreground hover:bg-muted hover:text-foreground',
            )}
          >
            {opt.label}
          </button>
        )
      })}
    </div>
  )
}
